/**
 * GroupTile — 88px group thumbnail used in the My Groups carousel.
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { Group } from '@wlb/shared/types/groups';
import { GroupsTabIcon } from '../../components/ui/icons';
import { resolveGroupImageUrl } from './groupMedia';
import './groups.css';

interface GroupTileProps {
  group: Group;
  onSelect: (group: Group) => void;
}

export function GroupTile({ group, onSelect }: GroupTileProps) {
  const { t } = useTranslation();
  const imageUrl = resolveGroupImageUrl(group.groupImage);

  return (
    <button
      type="button"
      className="group-tile"
      onClick={() => onSelect(group)}
      aria-label={t('home.groups.accessibility.openGroup', { name: group.groupName })}
    >
      {imageUrl ? (
        <img className="group-tile__image" src={imageUrl} alt="" aria-hidden />
      ) : (
        <span className="group-tile__placeholder" aria-hidden><GroupsTabIcon size={32} /></span>
      )}
      <span className="group-tile__name">{group.groupName}</span>
    </button>
  );
}
